import { render, staticRenderFns } from "./flFooter.vue?vue&type=template&id=81204454"
import script from "./flFooter.vue?vue&type=script&lang=js"
export * from "./flFooter.vue?vue&type=script&lang=js"
import style0 from "./flFooter.vue?vue&type=style&index=0&id=81204454&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports